export const AUTH_SESSION_EXPIRED_EVENT = "lastiqo:auth-session-expired";

export const clearAuthStorage = () => {
  localStorage.removeItem("pl_auth");
  localStorage.removeItem("pl_token");
  localStorage.removeItem("pl_kullanici");
};

export const redirectToLogin = () => {
  const loginHash = "#/login";

  if (window.location.hash !== loginHash) {
    window.location.hash = loginHash;
    return;
  }

  window.history.replaceState(null, "", `${window.location.pathname}${loginHash}`);
};

export const endAuthSession = (reason = "expired") => {
  clearAuthStorage();
  window.dispatchEvent(
    new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, {
      detail: { reason },
    })
  );
  redirectToLogin();
};
